import { env } from 'lib/env';

const DEFAULT_INTERVAL_SECONDS = 60;
const envInterval = Number(env.REACT_APP_AUTOMATIC_SAVE_INTERVAL_SECONDS);

// use of '||' is intentinal so that default is used if value is 0
export const saveIntervalSeconds = Number.isNaN(envInterval) || !envInterval ? DEFAULT_INTERVAL_SECONDS : envInterval;
